'use strict';

class SesamiManager {
  constructor(shopId) {
    // 1. Solo inicializamos con el shopId
    this.shopId = shopId || "20219592804";

    // Extraemos el primer servicio disponible del mapa generado en Liquid
    let initialProductId = null;
    let initialVariantId = null;

    if (window.SesamiProductsMap && Object.keys(window.SesamiProductsMap).length > 0) {
      //const firstHandle = Object.keys(window.SesamiProductsMap)[1];
      const defaultProduct = window.SesamiProductsMap['testing'];
      initialProductId = defaultProduct.id;
      initialVariantId = defaultProduct.variantId;
    }

    this.productId = initialProductId;
    this.variantId = initialVariantId;

    this.sdkInstance = null;
    this.teamMembers = {}; // Guardaremos los recursos mapeados por su ID
    this.isReady = false;

    this.init();
  }

  async init() {
    console.log("🚀 [SesamiManager] Inicializando motor de reservas...");

    if (!this.productId) {
      console.error("❌ [SesamiManager] No se encontraron servicios de Sesami en window.SesamiProductsMap");
      return;
    }

    // 1. Inicializar el SDK nativo de Sesami
    // Validamos el nombre de la clase global que inyecta el script de Sesami

    if (typeof SesamiSDK !== 'undefined') {
      this.sdkInstance = new SesamiSDK({
        shopId: this.shopId,
        serviceId: this.productId,
        productId: this.productId,
        variantId: this.variantId,
        quantity: 1,
        autoLoad: true
      });

      await this.sdkInstance.init();
      window.sesami = this.sdkInstance; // Compatibilidad global
    } else {
      console.warn("⚠️ [SesamiManager] El SDK de Sesami no se encuentra disponible en el entorno global.");
      return;
    }

    // 2. Extraer recursos (Team Members) usando el método del SDK
    await this.loadSesamiResources();

    // 3. Activar el interceptor de red para flujos de reserva
    this.initNetworkInterceptor();

    this.isReady = true;
    document.dispatchEvent(new CustomEvent('sesami:manager:ready', { detail: this }));
  }

  async loadSesamiResources() {
    try {
      // Obtenemos la configuración masiva de Sesami
      const config = await this.sdkInstance.getConfig();

      // Definimos un avatar fallback (Sesami suele proveer uno en config.defaultResourceAvatar)
      const fallbackImage = config.defaultResourceAvatar || config.defaultTeamMemberAvatar || 'https://cdn.shopify.com/s/files/1/0202/1959/2804/files/default-avatar.jpg';

      // Iteramos sobre la estructura de locaciones V2 para mapear los recursos
      if (config.locations && config.locations.length > 0) {
        config.locations.forEach(location => {
          if (location.resourceGroups && location.resourceGroups.length > 0) {
            location.resourceGroups.forEach(group => {
              if (group.resources && group.resources.length > 0) {
                group.resources.forEach(resource => {

                  // Poblamos nuestro atributo de clase
                  this.teamMembers[resource.id] = {
                    id: resource.id,
                    name: resource.name,
                    image: resource.image || fallbackImage,
                    type: resource.type || 'Especialista'
                  };

                });
              }
            });
          }
        });
      }

      console.log("✅ [SesamiManager] Recursos extraídos exitosamente del SDK:", this.teamMembers);
    } catch (error) {
      console.error("❌ [SesamiManager] Error al extraer configuración de Sesami:", error);
    }
  }

  // Método auxiliar para despachar el recurso requerido
  getResource(id) {
    if (this.teamMembers[id]) {
      return this.teamMembers[id];
    }
    return {
      "id": "6a4dbc0abf2c4a2ea9663a9f",
      "name": "Beatriz Ramirez",
      "image": "https://cdn.sesami.co/default_avatar.png",
      "type": "Esthetician"
    };
  }

  initNetworkInterceptor() {
    const originalFetch = window.fetch;
    const self = this;

    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';

      // Interceptamos peticiones de éxito hacia el endpoint de booking
      if (url.includes('/api/v1/book') && response.status === 200) {
        try {
          const clone = response.clone();
          const data = await clone.json();

          if (data && data.variantId && data.datetime) {
            console.log("🎯 [SesamiManager] Reserva completada interceptada:", data);

            const fechaCita = data.datetime.split('T')[0];
            const horaCita = new Date(data.datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

            const staffObj = self.getResource(data.teamMember);

            const infoReserva = {
              variantId: data.variantId,
              bookingId: data._id || data.id,
              serviceTitle: data.variantTitle || "Tratamiento Clínico",
              date: fechaCita,
              time: horaCita,
              staffName: staffObj.name,
              staffImage: staffObj.image, // La imagen ya viene validada desde getResource
              price: data.price ? `$${data.price}` : '$0.00',
              paid: false
            };

            self.syncToShopifyCart(infoReserva);
          }
        } catch (e) {
          console.error("Error al procesar la carga útil de la reserva:", e);
        }
      }
      return response;
    };
  }

  async syncToShopifyCart(reserva) {
    // Recopilar los sectionIds de todos los cart-items-component presentes en el DOM.
    // Shopify los usará para devolver el HTML pre-renderizado de cada sección del carrito,
    // lo que permite que CartItemsComponent use morphSection (quirúrgico) en lugar de
    // sectionRenderer.renderSection (que re-renderiza el header completo y rompe el scroll).
    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = [];
    cartItemsComponents.forEach((el) => {
      if (el instanceof HTMLElement && el.dataset.sectionId) {
        sectionIds.push(el.dataset.sectionId);
      }
    });

    const formData = {
      items: [{
        id: reserva.variantId,
        quantity: 1,
        properties: {
          '_sesami_booking_id': reserva.bookingId,
          '_date': reserva.date,
          '_time': reserva.time,
          '_staff_name': reserva.staffName,
          '_staff_image': reserva.staffImage
        }
      }],
      sections: sectionIds.join(','),
      sections_url: window.location.pathname,
    };

    try {
      const res = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const cartData = await res.json();

      if (cartData.status) {
        console.error('❌ [SesamiManager] Error al agregar al carrito:', cartData.message, cartData.errors);
        return;
      }

      console.log('✅ [SesamiManager] Reserva inyectada en el carrito de Shopify', cartData);

      // Obtener el carrito completo para tener item_count e items actualizados.
      // CartDrawerComponent lo usa para el anuncio de accesibilidad y el icono del carrito.
      const cartResponse = await fetch('/cart.js');
      const fullCart = await cartResponse.json();

      const cartEvent = new CustomEvent('cart:update', {
        bubbles: true,
        composed: true,
        detail: {
          resource: fullCart,
          sourceId: 'sesami-manager',
          data: {
            source: 'sesami-manager',
            variantId: reserva.variantId.toString(),
            itemCount: fullCart.item_count,
            sections: cartData.sections, // HTML pre-renderizado por Shopify — clave para morphSection
          }
        }
      });

      document.dispatchEvent(cartEvent);

    } catch (err) {
      console.error('❌ [SesamiManager] Error al enviar payload al carrito:', err);
    }
  }
}